import React, { ImgHTMLAttributes } from 'react'

import { useT } from 'src/core/hooks/use-translation'

function Image({ title, alt, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const { t } = useT()
  return <img alt={t(alt)} title={t(title)} {...props} />
}

export default Image
